import { React, useState } from 'react'
import styles from './Dashboard.module.scss'
import GeoProvider from '../../components/GeoProvider'
import Content from '../../components/Content'
import Layout from '../../components/Layout'
import ProductLinks from './ProductLinks'
import dataDisplayOptions from './dataDisplayOptions'
import Gender from './GenderAge'
import RaceEthnicityGraph from '../RaceEthnicity'
import RSVMap from './RSVMap'
import FluMap from './FluMap'
import CovidMap from './CovidMap'
import BirthTrendMap from './BirthTrendMap'
import VulnerabilityMap from './VulnerabilityMap'
import AllergiesMap from './AllergiesMap'
import PolicyAttestation from '../../components/PolicyAttestation'
import { startDate, endDate, displayDate } from './dates'
import SelectList from '../../components/SelectMenuList'
import typeDisplayOptions from './typeDisplayOptions'
import { useAuthState } from '../../components/AuthProvider'
import SystemNotification from './SystemNotification'
import { useNavigate } from 'react-router-dom'
import MeningitisMap from './MeningitisMap'
import ShinglesMap from './ShinglesMap'
import UTIMap from './UTIMap'
import dataDisplayOptionsMen from '../../pages/Meningitis/dataDisplayOptions'
import dataDisplayOptionsUti from '../../pages/UTIDashboard/dataDisplayOptions'
import SurveillanceMap from './SurveillanceMap'
import VaccinationMap from './VaccinationMap'
import RareDiseaseMap from './RareDiseaseMap'

const Dashboard = () => {   
  const { user } = useAuthState()

  const history = useNavigate()
  return (
    <Layout>
      <Content>
        <GeoProvider>
          <SystemNotification />
        </GeoProvider>
        <div className={styles.base}>
          <div className={styles.body}>
            <div className={styles.pageHeader}>
              <div className={styles.pageHeaderText}>
                <SelectList
                  dropdownData={typeDisplayOptions}
                  defaultValue={'home'}
                  defaultLabel={'My Dashboard'}
                />
              </div>
            </div>
            <div className={styles.pageMaps}>
              <div className={styles.rsvPanel}>
                <a
                  href=""
                  onClick={() => {
                    history('/rsvdashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>RSV Incidence</span>
                      </div>
                    </div>

                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      mapOptions={dataDisplayOptions[0]['options'][0]}
                      regionSelected={'state'}
                    >
                      {' '}
                      <RSVMap />
                    </GeoProvider>
                  </div>
                </a>
              </div>

              <div className={styles.fluPanel}>
                <a
                  href=""
                  onClick={() => {
                    history('/fludashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>Flu Incidence</span>
                      </div>
                    </div>

                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      mapOptions={dataDisplayOptions[0]['options'][3]}
                      regionSelected={'state'}
                    >
                      {' '}
                      <FluMap />
                    </GeoProvider>
                  </div>
                </a>
              </div>
              <div className={styles.covidPanel}>
                <a
                  href=""
                  onClick={() => {
                    history('/coviddashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span>COVID-19 Incidence</span>
                      </div>
                    </div>
                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      mapOptions={dataDisplayOptions[0]['options'][4]}
                      regionSelected={'state'}
                    >
                      {' '}
                      <CovidMap />
                    </GeoProvider>
                  </div>
                </a>
              </div>
            </div>
            <div className={styles.pageMaps}>
              <div
                className={styles.vulPanel}
                style={{ display: user.role === 'External' ? 'none' : 'block' }}
              >
                <a
                  href=""
                  onClick={() => {
                    history('/vulnerabilitydashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>Vulnerability</span>
                      </div>
                    </div>

                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={'October 2023'}
                      mapOptions={dataDisplayOptions[0]['options'][1]}
                      regionSelected={'state'}
                    >
                      {' '}
                      <VulnerabilityMap />
                    </GeoProvider>
                  </div>
                </a>
              </div>
              <div className={styles.allrgPanel}>
                <a
                  href=""
                  onClick={() => {
                    history('/allergiesdashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>Allergies and Air Quality</span>
                      </div>
                    </div>

                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      mapOptions={dataDisplayOptions[0]['options'][2]}
                      regionSelected={'state'}
                    >
                      {' '}
                      <AllergiesMap />
                    </GeoProvider>
                  </div>
                </a>
              </div> 
              {process.env.REACT_APP_FEATURE_FLAG === 'true' && (
              <div className={styles.btPanel}>
                <a
                  href=""
                  onClick={() => {
                    history('/birthtrenddashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>Birth & Trend</span>
                      </div>
                    </div>

                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      mapOptions={dataDisplayOptions[0]['options'][5]}
                      regionSelected={'state'}
                    >
                      {' '}
                      <BirthTrendMap />
                    </GeoProvider>
                  </div>
                </a>
              </div> 
              )}
            </div>
            {process.env.REACT_APP_FEATURE_FLAG === 'true' && (
            <div className={styles.pageMaps}>
              <div
                className={styles.survPanel}
                style={{ display: user.role === 'External' ? 'none' : 'block' }}
              >
                <a
                  href=""
                  onClick={() => {
                    history('/surveillancedashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>Surveillance</span>
                      </div>
                    </div>

                     <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      mapOptions={dataDisplayOptions[0]['options'][5]}
                      regionSelected={'state'}
                    >
                      {' '}
                      <SurveillanceMap />
                    </GeoProvider>
                  </div>
                </a>
              </div>
              <div className={styles.vaccPanel}>
                <a
                  href=""
                  onClick={() => {
                    history('/vaccinationdashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>Vaccination</span>
                      </div>
                    </div>

                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      mapOptions={dataDisplayOptions[0]['options'][3]}
                      regionSelected={'state'}
                    >
                      {' '}
                      <VaccinationMap />
                    </GeoProvider>
                  </div>
                </a>
              </div> 
                <div
                className={styles.rarePanel}
                style={{ display: user.role === 'External' ? 'none' : 'block' }}
              >
                <a
                  href=""
                  onClick={() => {
                    history('/rarediseasedashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>Rare Disease</span>
                      </div>
                    </div>

                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      mapOptions={dataDisplayOptions[0]['options'][3]}
                      regionSelected={'state'}
                    >
                      {' '}
                      <RareDiseaseMap />
                    </GeoProvider>
                  </div>
                </a>
              </div>
            </div>)}

             {process.env.REACT_APP_FEATURE_FLAG === 'true' && (
            <div className={styles.pageMaps}>
              
              <div className={styles.utiPanel}>
                <a
                  href=""
                  onClick={() => {
                    history('/utidashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>UTI Dashboard</span>
                      </div>
                    </div>

                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      mapOptions={dataDisplayOptionsUti[0]['options'][0]}
                     indicatorName={dataDisplayOptionsUti[0]['options'][0].indicatorName}
                      regionSelected={'state'}
                    >
                      {' '}
                      <UTIMap />
                    </GeoProvider>
                  </div>
                </a>
              </div>
               <div className={styles.meningitisPanel}>
                  <a
                  href=""
                  onClick={() => {
                    history('/meningitisdashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>Meningitis</span>
                      </div>
                    </div>

                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      locationName={"nat"}
                      mapOptions={dataDisplayOptionsMen[0]['options'][0]}
                      indicatorName={dataDisplayOptionsMen[0]['options'][0].indicatorName}
                      regionSelected={'state'}
                    >
                      {' '}
                      <MeningitisMap />
                    </GeoProvider>
                  </div>
                </a>
              </div>
              <div className={styles.meningitisPanel}>
                  <a
                  href=""
                  onClick={() => {
                    history('/shinglesdashboard')
                  }}
                >
                  <div className={styles.dashboardCard}>
                    <div className={styles.dashboardCardHeader}>
                      <div className={styles.mapHeaderDiv}>
                        <span className={styles.mapName}>Shingles</span>
                      </div>
                    </div>

                    <GeoProvider
                      startDate={startDate}
                      endDate={endDate}
                      displayDate={displayDate}
                      locationName={"nat"}
                      mapOptions={dataDisplayOptionsMen[0]['options'][0]}
                      indicatorName={dataDisplayOptionsMen[0]['options'][0].indicatorName}
                      regionSelected={'state'}
                    >
                      {' '}
                      <ShinglesMap />
                    </GeoProvider>
                  </div>
                </a>
              </div>
            </div>)}
            <div className={styles.productLinks}>
              <ProductLinks />
            </div>
            <div className={styles.ageGenderGraph}>
              <span className={styles.heading}>
                United States Census Bureau Population Data
              </span>
              <div className={styles.graphPanel}>
                <Gender geo_type="nat" geo_id="nat" />
              </div>
            </div>
            <div className={styles.raceEthnicity}>
              <RaceEthnicityGraph geo_type="nat" geo_id="nat" />
            </div>
          </div>
        </div>         
      </Content>
    </Layout>
  )
}

export default Dashboard